/* eslint-disable max-len */
import React, { useContext, useState, useEffect } from 'react';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { get, getJson } from 'session';
import ViewDocument from './ViewDocument';

function Permits({ data }) {
  const isBusinessPermitGenerated = _.get(data, 'included.ebplsApplication.attributes.business_permit_generated_at')
  const isSanitaryPermitGenerated = _.get(data, 'included.ebplsApplication.attributes.sanitary_permit_generated_at')
  const authProfile = getJson('profile') || {};
  const setModal = useContext(ModalContext);
  const [token, setToken] = useState("");

  useEffect(() => {
      const getToken = get("token") || "";
      setToken(getToken);
  }, []);

  const cUrlDownloadSanitary = 'api/v1/ebpls/administrator/transaction_histories/permits/{id}/preview_sanitary_permit'
  const cUrlDownloadBusiness = 'api/v1/ebpls/administrator/transaction_histories/permits/{id}/preview_business_permit'

  const srcDownload = (api) => {
    return `${process.env.REACT_APP_WS}${api.replace(
      "{id}",
      _.get(data, "id")
  )}?bearer_token=${token}&email=${_.get(
      authProfile,
      "email"
  )}`
  } 

  const handleViewPermit = (url) => e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewDocument url={url} />,
      title: `View Permit`,
      modalSize: 'modal-xl',
    });
  };

  return (
    <div className="p-3">
      <table className="transaction-table table table-striped table-borderless table-sm">
        <tbody>
          <tr>
            <th className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold" width="55%">
              Permit Name
            </th>
            <th className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold" width="20%">
              Date Generated
            </th>
            <th className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold" width="25%">
              Actions
            </th>
          </tr>
          {isSanitaryPermitGenerated && (
            <tr>
              <td className="text-dark">
                Sanitary Permit
              </td>
              <td>
                {moment(_.get(data, 'included.ebplsApplication.attributes.sanitary_permit_generated_at')).format('YYYY-MM-DD')}
              </td>
              <td>
                <a
                  className="btn-blank"
                  href={srcDownload(cUrlDownloadSanitary)}
                  target="_blank"
                  without="true"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-print icon-print cms-bg-color-primary" />
                </a>
                <button
                  type="button"
                  onClick={handleViewPermit(srcDownload(cUrlDownloadSanitary))}
                  className="btn-blank"
                >
                  <i className="far fa-eye icon-view-only" />
                </button>
              </td>
            </tr>
          )}
          {isBusinessPermitGenerated && (
            <tr>
              <td className="text-dark">
                Business Permit
              </td>
              <td>
                {moment(_.get(data, 'included.ebplsApplication.attributes.business_permit_generated_at')).format('YYYY-MM-DD')}
              </td>
              <td>
                <a
                  className="btn-blank"
                  href={srcDownload(cUrlDownloadBusiness)}
                  target="_blank"
                  without="true"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-print icon-print cms-bg-color-primary" />
                </a>
                
                <button
                  type="button"
                  onClick={handleViewPermit(srcDownload(cUrlDownloadBusiness))}
                  className="btn-blank"
                >
                  <i className="far fa-eye icon-view-only" />
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

Permits.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps
  ),
]);


export default enhance(Permits);
